import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewEncapsulation,
  Inject
} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import {
  interval
} from 'rxjs';

import {
  faCoffee,
  faLessThanEqual,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import {
  faFileUpload
} from '@fortawesome/free-solid-svg-icons';
import {
  faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons';
import {
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import {
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import {
  KeycloakProfile
} from 'keycloak-js';
import {
  KeycloakService
} from 'keycloak-angular';
import {
  environment
} from '../environments/environment';
import {
  THIS_EXPR
} from '@angular/compiler/src/output/output_ast';
import {
  SkipperService
} from './services/skipper.service';
import {
  getHtmlTagDefinition
} from '@angular/compiler';

import {MenuItem} from 'primeng/api';
//import * as jsPDF from 'jspdf';
import jspdf from 'jspdf';
import kjua from 'kjua';
import { formatDate } from '@angular/common';
import { timer } from 'rxjs';
import { style } from '@angular/animations';
interface Tipo {
  name: String,
    code: String
}
interface Juzgado {
  name: String,
    code: String
}

interface Condicion {
  name: String

}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
 
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements AfterViewInit, OnInit {
  userDetails: KeycloakProfile;
  sessionToken=''
  numbers = timer(5000, 1000*600);
  networkCheckerCounter=0
  networkCheckerOKCounter=0

  items: MenuItem[];
  activeItem: MenuItem;
  popSettingsDialog: boolean = false;

  @ViewChild('input') input: ElementRef;
  @ViewChild('bar') bar: ElementRef;
  // @ViewChild('ourForm', {static: true}) ourForm;
  ngAfterViewInit() {
   // console.log(this.input.nativeElement.innerHTML); 
  }

  constructor(private keycloakService: KeycloakService,
    private skipperService: SkipperService,
    private changeDetection: ChangeDetectorRef    
    ) { }

  async doLogout() {
    await this.keycloakService.logout();
  }

  showSettingsDialog() {
      this.popSettingsDialog = true;
  }

  closeSession()
  {

    this.skipperService.closeSession()
  //   console.log("cerrar sesion")
  //   let logout_url=environment.KC_URL + 'realms/' + environment.KC_REALM + '/protocol/openid-connect/logout?redirect_uri=' + environment.KEYCLOAK_AUTH_ADDRESS_ENC
  //  // console.log(logout_url);
  //   localStorage.clear();
    
  //  // alert()
  //   window.location.replace(logout_url);
  }

  async ngOnInit() {
    this.numbers.subscribe(x => this.startNetworkChecker());

 

    if (await this.keycloakService.isLoggedIn()) {
      console.log("logged in!!");
      this.userDetails = await this.keycloakService.loadUserProfile();        
      this.sessionToken= await this.keycloakService.getToken();
      console.log(this.sessionToken)
      console.log(this.userDetails)
      console.log(this.userDetails.firstName)

    }  



    this.items  = [
    
      { label: 'Documentación Subida', icon: 'pi pi-fw pi-cloud', routerLink: ['/tray']},
      { label: 'Subir Documento', icon: 'pi pi-fw pi-plus', routerLink: ['/uploader']},
      { label: 'Descarga con Link',icon : 'pi pi-fw pi-download', url: 'https://skipper-downloader.pjm.gob.ar/?from=skipper-uploader'},

      
      { label: `¡Hola, ${this.userDetails.firstName}!`, icon: 'pi pi-fw pi-user'},
      { label: 'Cerrar Sesión', icon: 'pi pi-fw pi-sign-out', styleClass: 'align-right', command: (event) => { this.closeSession() }}
    ];

    this.items[2].style = { 'color': 'blue' }; 
    


  }
  


  startNetworkChecker(){
    if((this.networkCheckerCounter-this.networkCheckerOKCounter)>2)
    {
      
      alert(environment.NETWORK_CONN_ISSUE_MESSAGE)
      this.networkCheckerCounter=0
      this.networkCheckerOKCounter=0
    }
    this.networkCheckerCounter++;
    this.skipperService.checkBackendReach().subscribe(r=>
    {
      ////console.log(r)
      this.networkCheckerOKCounter++;
    })
  }
}